var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "zw profile" },
    [
      _c("div", { staticClass: "user" }, [
        _c("span", [_vm._v(_vm._s(_vm.FullName))])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "options" },
        [
          _c(
            "router-link",
            {
              staticClass: "ui button",
              attrs: { tag: "div", to: "/dashboard" },
              nativeOn: {
                click: function($event) {
                  return _vm.closeSidebar.apply(null, arguments)
                }
              }
            },
            [
              _c("i", { staticClass: "home icon" }),
              _vm._v(
                "\n\t\t\t" + _vm._s(_vm.$t("sidebar.profile.home")) + "\n\t\t"
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "ui button",
              attrs: { tag: "div", to: "/profile" },
              nativeOn: {
                click: function($event) {
                  return _vm.closeSidebar.apply(null, arguments)
                }
              }
            },
            [
              _c("i", { staticClass: "user icon" }),
              _vm._v(
                "\n\t\t\t" +
                  _vm._s(_vm.$t("sidebar.profile.profile")) +
                  "\n\t\t"
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "ui red button large",
              on: {
                click: function($event) {
                  return _vm.showLogout()
                }
              }
            },
            [
              _c("i", { staticClass: "remove user icon" }),
              _vm._v(
                "\n\t\t\t" + _vm._s(_vm.$t("sidebar.profile.logout")) + "\n\t\t"
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "semantic-modal",
        {
          staticClass: "basic small",
          attrs: {
            settings: {
              content_classes: { content: false },
              closeable: true,
              closeable_button: false
            }
          },
          model: {
            value: _vm.showModal,
            callback: function($$v) {
              _vm.showModal = $$v
            },
            expression: "showModal"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "ui icon header",
              attrs: { slot: "header" },
              slot: "header"
            },
            [
              _c("i", { staticClass: "home icon" }),
              _vm._v(
                "\n\t\t\t" +
                  _vm._s(_vm.$t("modals.logout.areyousure")) +
                  "\n\t\t"
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "actions",
              attrs: { slot: "actions" },
              slot: "actions"
            },
            [
              _c(
                "div",
                { staticClass: "ui red basic cancel inverted button" },
                [_vm._v(_vm._s(_vm.$t("globals.buttons.no")))]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "ui green ok inverted button",
                  on: {
                    click: function($event) {
                      return _vm.logOut()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("globals.buttons.yes")))]
              )
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9d51191c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9d51191c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/SidebarProfile.vue
// module id = UxqQ
// module chunks = 1